import { HomeworkPage } from './HomeworkPage'

export default HomeworkPage
